<template>
  <v-card>
    <v-card-title class="headline">
      <layout-no-padding>
        <v-flex xs12>
          <span>
            {{ selectedAction.text}} for Selected batch allocations?
            <span
              class="grey--text subheading"
            ></span>
          </span>
        </v-flex>
        <v-flex
          xs12
          class="grey--text title"
        >This action will affect {{selectedCount}} batch allocation(s).</v-flex>
      </layout-no-padding>
    </v-card-title>
    <v-form @submit.prevent="$emit('confirm', notes)">
      <v-card-text>
        <v-text-field label="Notes" v-model="notes"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" flat @click="$emit('close')">No</v-btn>
        <v-btn color="green darken-1" flat type="submit" :loading="loading">Yes</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
export default {
  props: {
    selectedAction: Object,
    selectedCount: Number,
    loading: Boolean
  },
  data() {
    return {
      notes: ""
    }
  }
};
</script>

<style>
</style>